import React from 'react'

const Analytics = () => {
  return (
    <div className='FadeIn'>Analytics</div>
  )
}

export default Analytics